import { render, staticRenderFns } from "./GlobalNotifications.vue?vue&type=template&id=65f96ab3&scoped=true&"
import script from "./GlobalNotifications.vue?vue&type=script&lang=js&"
export * from "./GlobalNotifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f96ab3",
  null
  
)

export default component.exports